import { render, staticRenderFns } from "./GroupInvitation.vue?vue&type=template&id=76cd2d7c&scoped=true"
import script from "./GroupInvitation.vue?vue&type=script&lang=js"
export * from "./GroupInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd2d7c",
  null
  
)

export default component.exports